import React from "react";

import { Grid, Typography } from "@mui/material";

import {
  StandardPriceRange,
  StandardRadioGroup,
  StandardTextField,
} from "../../../components/standard-form-fields";

export default () => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6">委託 - 音樂人</Typography>
    </Grid>
    <StandardTextField
      name="music.format"
      required
      label="作品形式"
      placeholder="有人聲、純伴奏等"
      registerProps={{
        required: "請填寫您的作品形式",
      }}
    />
    <StandardTextField
      name="music.genre"
      required
      label="擅長類型"
      placeholder="古典、流行、RAP等"
      registerProps={{
        required: "請填寫您的擅長音樂類型",
      }}
    />
    <StandardTextField
      name="music.instruments"
      required
      label="樂器偏好"
      placeholder="鋼琴、小提琴、爵士鼓、無使用樂器等，多種樂器請列明"
      registerProps={{
        required: "請填寫您的樂器偏好",
      }}
    />
    <StandardRadioGroup
      name="music.canCreateSoundEffect"
      choices={[
        { value: "true", label: "會" },
        { value: "false", label: "否" },
      ]}
      required
      label="會否製作sound effect"
      registerProps={{ required: "請選擇您會否接受音效製作的委託" }}
    />
    <StandardPriceRange
      name="music.price"
      required
      label="商業委託價格範圍"
      registerProps={{
        required: "請提供您可接受的委託價格",
      }}
    />
    <StandardTextField
      name="music.priceDetails"
      required
      label="商業委託價格詳情"
      placeholder="請註明委託內容及對應的價格（如: 一幅插畫單位角色含背景 2000 HKD 或 三萬字漫畫故事劇本 30000 NTD）"
      registerProps={{
        required: "請提供委託內容及對應的價格",
      }}
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="music.additionalInfo"
      label="補充說明"
      placeholder="如有任何特別技能、接案經驗或委託相關的注意事項，歡迎在此註明"
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="music.referenceLink"
      required
      label="作品網站 / 作品連結"
      placeholder="您的作品網站 / 作品連結"
      registerProps={{
        required: "請提供作品樣本供客戶參考",
      }}
    />
  </>
);
